import type {LatLng} from "leaflet";
// @ts-ignore
import {encode} from "google-polyline";
import Leaflet_map from "@wikicasa/common/leaflet_map";



export function parsePoints(polygonFromMap: string): Array<LatLng> | undefined {

    if (!polygonFromMap)
        return;

    const numbers: RegExpMatchArray | null = polygonFromMap.match(/[-]?[\d]*[.]?[\d]+/g);

    if (!numbers)
        return;

    const latLngs: Array<LatLng> = [];

    for (let i = 0; i < numbers.length; i++) {
        latLngs.push({lat: parseFloat(numbers[i + 1]), lng: parseFloat(numbers[i])} as LatLng);
        i++;
    }

    return latLngs;
}

/**
 * @param polygon An array of latitude and polygon that will be used to design an area in a map
 * @param forUrl If true, the output string will be encoded as a URI so respecting the UTF-8 encoding
 * */
export function encodePolygon(polygon: Array<LatLng>, forUrl = true): string {
    const polygonArr: Array<any> = [];
    polygon.forEach((p: LatLng) => {
        polygonArr.push([p.lat, p.lng]);
    });
    const encodedPolygon = encode(polygonArr);
    return forUrl ? encodeURIComponent(encodedPolygon) : encodedPolygon;
}

export function getMinMaxLatLng(polygon: Array<LatLng>): { miny: number; maxy: number; minx: number; maxx: number } {
    const minmax = {
        miny: polygon[0].lat,
        maxy: polygon[0].lat,
        minx: polygon[0].lng,
        maxx: polygon[0].lng
    };
    polygon.forEach((p: LatLng) => {
        minmax.miny = Math.min(minmax.miny, p.lat);
        minmax.maxy = Math.max(minmax.maxy, p.lat);
        minmax.minx = Math.min(minmax.minx, p.lng);
        minmax.maxx = Math.max(minmax.maxx, p.lng);
    });
    return minmax;
}

export function removeDuplicatePoints(latLngs: Array<LatLng>): Array<LatLng> {
    if (latLngs.length <= 0) return [];

    const uniqueCoordinates = new Set();
    const unique = latLngs.filter(x => {
        const isDuplicate = uniqueCoordinates.has(x.lat + x.lng);
        const coordinate = x.lat + x.lng;
        uniqueCoordinates.add(coordinate);
        return !isDuplicate;

    });

    return unique;
}

export function calcPolygonCenter(points: Array<LatLng>): LatLng {

    let lat = 0;
    let lng = 0;

    for (let i = 0; i < points.length; i++) {

        const point = points[i];

        lat += point.lat;
        lng += point.lng;
    }

    return {lat: lat / points.length, lng: lng / points.length} as LatLng;
}

export function validateMap(map: Leaflet_map): boolean {

    const mapRange = window._mapRange || 10000;

    if (map) {
        const center = map.getShape()?.getCenter();
        const points = map.getShapePoints();
        if (points) {
            for (let i = 0; i < points.length; i++) {
                if (map.getDistance(points[i], center) > mapRange)
                    return false;
            }
        }
        return true;
    }
    return false;
}

export function getPolygonString(shapePoints: Array<LatLng>): string {
    let polygonString = "POLYGON((";
    shapePoints.forEach((point: LatLng) => {
        polygonString += `${point.lng} ${point.lat}, `;
    });
    polygonString += `${shapePoints[0].lng} ${shapePoints[0].lat}))`;
    return polygonString;
}